import styled from "styled-components";

const H1 = styled.h1`
  font-size: 5.6rem;
  letter-spacing: -1.8px;
  font-weight: 900;
  line-height: 1;
`

export default H1